import Axios from "../utils/tms-axios/tms-axios";
import ReportsAxios from "../utils/tms-axios/tms-reports-axios";

const TmsAnnadanamService = {
  getAnnadanam: async (page, limit) => {
    const resp = await Axios.get(
      `annadanam/all/${localStorage.getItem(
        "templeId"
      )}?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  createAnnadanam: async (body) => {
    const resp = await Axios.post(`annadanam/new`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deleteAnnadanam: async (productId) => {
    const resp = await Axios.delete(`annadanam/delete/${productId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  viewAnnadanam: async (productId) => {
    const resp = await Axios.get(`annadanam/by-id?annadanamId=${productId}`, {
      headers: {
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  editAnnadanam: async (body) => {
    const resp = await Axios.put(`annadanam/edit`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  //annadanam-slots
  getAnnadanamSlots: async (id) => {
    const resp = await Axios.get(`annadanam/slots/byAnnadanamId/${id}`, {
      headers: {
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  createAnnadanamSlots: async (body) => {
    const resp = await Axios.post(`annadanam/slots/new`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  editAnnadanamSlots: async (body) => {
    const resp = await Axios.put(`annadanam/slots/edit`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  deleteAnnadanamSlots: async (slotId) => {
    const resp = await Axios.delete(`annadanam/slots/delete/${slotId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  updateTerms: async (productId, termsData, onlineterms, ticketType) => {
    const resp = await Axios.patch(
      `annadanam/metadata/${productId}`,
      {
        termsAndConditions: termsData,
        onlineTermsAndConditions: onlineterms,
        ticketType: ticketType ? "mini_ticket" : "full_ticket",
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  //annadanam-slots-counters

  //annadanam-slots
  getAnnadanamSlotCounter: async (id) => {
    const resp = await Axios.get(
      `annadanam-counter/counters/bySlotId?annadanamSlotId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  createAnnadanamSlotCounter: async (body) => {
    const resp = await Axios.post(`annadanam-counter/counters/new`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  editAnnadanamSlotCounter: async (body) => {
    const resp = await Axios.put(`annadanam-counter/counters/edit`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  deleteAnnadanamSlotCounter: async (slotId) => {
    const resp = await Axios.delete(
      `v1/annadanam-counter-slot/delete/${slotId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  //annadanam booking

  fetchAnnadanamBookingSlots: async (tickets, bookingDate) => {
    const resp = await Axios.get(
      `annadanam-counter/counter-query?tickets=${tickets}&bookingDate=${bookingDate}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  // fetchProtocolAnnadanam: async () => {
  //   const resp = await Axios.get(`v1/annadanam-online-booking/valid-products`, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //       "X-Temple-Id":  localStorage.getItem("templeId")

  //     },
  //   });
  //   return resp.data;
  // },

  // fetchProtocolSlots: async (fromDate, toDate, multipleProductIds) => {
  //   let url = `v1/annadanam-slot-daily-quota?fromDate=${fromDate}&toDate=${toDate}&multipleProductIds=${multipleProductIds}&type=protocol`;
  //   // &onlyOnlineEnabled=false&type=protocol${multipleProductIds
  //   //   .map((item) => `&multipleProductIds=${Number(item)}`)
  //   //   .join("")}
  //   const resp = await Axios.get(url, {
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //       "X-Temple-Id":  localStorage.getItem("templeId")

  //     },
  //   });
  //   return resp.data;
  // },

  annadanamBooking: async (id, gender, ImageUrl) => {
    const resp = await Axios.post(
      `cart-counter/annadanam`,
      {
        noOfPersons: 1,
        annadanamSlotId: id,
        gender: gender,
        imageUrl: ImageUrl,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  annadanamReport: async ({
    format,
    tableCurrentPage,
    tablePageSize,
    fromDate,
    toDate,
    dateType,
    sortType,
    counter,
    shift,
    slot,
    anndanamType,
  }) => {
    let query = `/annadanam-report/bookings?page=${tableCurrentPage}&limit=${tablePageSize}&bookingFromDate=${fromDate}&bookingToDate=${toDate}&dateType=${dateType}`;

    if (counter && counter !== "") {
      query += `&counterId=${counter}`;
    }
    if (shift && shift !== "") {
      query += `&counterShiftTimingId=${shift}`;
    }
    if (slot && slot !== "") {
      query += `&annadanamSlotId=${slot}`;
    }
    if (anndanamType && anndanamType !== "") {
      query += `&annadanamId=${anndanamType}`;
    }
    const axios = format === "email" ? Axios : ReportsAxios;
    const resp = await axios.get(query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  annadanamReportOnline: async ({
    format,
    tableCurrentPage,
    tablePageSize,
    fromDate,
    toDate,
    dateType,
    sortType,
    counter,
    shift,
    slot,
    annadanamType,
    paymentStatus,
    selectedPartner,
  }) => {
    let query = `v1/annadanam-online-report/booking?format=${format}&paymentStatus=${paymentStatus}&page=${tableCurrentPage}&limit=${tablePageSize}&bookingFromDate=${fromDate}&bookingToDate=${toDate}&dateType=${dateType}&order=${sortType}`;

    if (counter && counter !== "") {
      query += `&counterId=${counter}`;
    }
    if (shift && shift !== "") {
      query += `&counterShiftTimingId=${shift}`;
    }
    if (slot && slot !== "") {
      query += `&annadanamSlotId=${slot}`;
    }
    if (annadanamType && annadanamType !== "") {
      query += `&productId=${annadanamType}`;
    }
    if (selectedPartner !== "" && selectedPartner) {
      query += `&partnerCode=${selectedPartner}`;
    }
    const axios = format === "email" ? Axios : ReportsAxios;
    const resp = await axios.get(query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  //disable-dates
  fetchdisabledates: async (productId, page, limit) => {
    const resp = await Axios.get(
      `annadanam/disable-date/by-product-id/${productId}?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  createDisableDates: async (
    productIds,
    startDate,
    endDate,
    description,
    onlineDisabled,
    counterDisabled
  ) => {
    const resp = await Axios.post(
      `annadanam/disable-date/create`,
      {
        productIds: productIds,
        startDate: startDate,
        endDate: endDate,
        description: description,
        onlineDisabled: onlineDisabled,
        counterDisabled: counterDisabled,
        protocolDisabled: false,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  deleteDisableDate: async (id) => {
    const resp = await Axios.delete(`annadanam/disable-date/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  getConsolidateReport: async ({
    format,
    productId,
    from,
    to,
    counter,
    shift,
    groupBy,
    bookingType,
  }) => {
    let query = `v1/annadanam-counter-report/consolidated-ticket-collection-for-product?format=${format}&bookingFromDate=${from}&bookingToDate=${to}`;

    if (productId !== "") {
      query += `&productId=${productId}`;
    }
    if (counter) {
      query += `&counterId=${counter}`;
    }
    if (shift) {
      query += `&counterShiftTimingId=${shift}`;
    }
    if (groupBy !== "") {
      query += `&groupBy=${groupBy}`;
    }
    if (bookingType) {
      query += `&dateType=${bookingType}`;
    }
    let res = await ReportsAxios.get(query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return res.data;
  },

  getOnlineConsolidateReport: async ({
    format,
    productId,
    from,
    to,
    groupBy,
    bookingType,
  }) => {
    let query = `v1/annadanam-online-report/consolidated-ticket-collection-for-product?format=${format}&bookingFromDate=${from}&bookingToDate=${to}`;

    if (productId !== "") {
      query += `&productId=${productId}`;
    }
    if (groupBy !== "") {
      query += `&groupBy=${groupBy}`;
    }
    if (bookingType) {
      query += `&dateType=${bookingType}`;
    }
    let res = await ReportsAxios.get(query, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return res.data;
  },

  getQuotaData: async ({ from, to, productIds, type }) => {
    const resp = await Axios.get(
      `v1/annadanam-slot-daily-quota?fromDate=${from}&toDate=${to}&productSlotId=${productIds}&type=${type}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },
  updateQuotaData: async (body) => {
    const res = await Axios.post(`v1/annadanam-slot-daily-quota`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return res.data;
  },
  getPartnersForAnnadanam: async (productId) => {
    const resp = await Axios.get(`annadanam/partners/${productId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  darshnamPartnerAccess: async (body) => {
    const resp = await Axios.patch(`annadanam/partner-access`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
};

export default TmsAnnadanamService;
